import { PLAY_SERVICE_V1_URL } from 'utils/constants';

export const GET_CHAPTER_SUGGESTION_URL_PATTERN = `${PLAY_SERVICE_V1_URL}/chapter/:chapterId/suggestion`;

export const EVENT_TRACKING_URL_PATTERN = `${PLAY_SERVICE_V1_URL}/event/receive`;
